import { t } from '@/core/localization';
import { getValidEnumValues } from '../convert';
import { mixed } from './yup.extensions';
export const oneOfEnum = ({ enum: enumObject, errorMessage, includeUnknown = false, unknownValue = 0, }) => mixed().test('one-of-enum', errorMessage ?? t('invalid.value.has.been.entered'), (value) => value !== undefined && getValidEnumValues(enumObject, includeUnknown, unknownValue).includes(value));
